let uid = 1
let lang = '首页'
let err = "错误"
let logout = "退出登录"
import cookie from 'js-cookie';
import Vue from 'vue';
Vue.prototype.cookie = cookie;
function genUid () {
    return 'sr-' + uid++
}
function genULang () {
    return (cookie.get('mfs_lang') == 'en-us' || cookie.get('mfs_lang') == 'en-US') ? lang = 'Home page' : lang = '首页'
}
function genUErr () {
    return (cookie.get('mfs_lang') == 'en-us' || cookie.get('mfs_lang') == 'en-US') ? err = 'Remarks' : err = '错误'
}
function genUOut () {
    return (cookie.get('mfs_lang') == 'en-us' || cookie.get('mfs_lang') == 'en-US') ? logout = 'Log out' : logout = '退出登录'
}
/**
 * meta: { closable: 是否可关闭, showsSd: 是否显示侧边栏 }
 */
const ROUTES = {
    ROOT: {
        path: '/',
        name: 'home',
        meta: { id: genUid(), code: genUid(), moduleName: genULang(), closable: false, showSd: true, },
        component: () => import('@/modules/home')
    },
    ERROR: {
        path: '/error',
        meta: { id: genUid(), code: genUid(), moduleName: genUErr(), closable: true, showSd: true },
        component: () => import('@/modules/error')
    },
    LOGOUT: {
        path: '/logout',
        meta: { id: genUid(), code: genUid(), moduleName: genUOut(), closable: true, showSd: true, isGlobal: true },
        component: () => import('@/modules/logout')
    },
    // APPLY: {
    //     path: '/apply',
    //     meta: { id: genUid(), code: genUid(), moduleName: 'USF权限申请', closable: true, showSd: false,isGlobal: true },
    //     component: () => import('@/modules/apply')
    // },
    // APPLY2: {
    //     path: '/apply2',
    //     meta: { id: genUid(), code: genUid(), moduleName: 'USF权限申请2', closable: true, showSd: false,isGlobal: true },
    //     component: () => import('@/modules/apply')
    // },
}

export default ROUTES
